


















import Vue from 'vue'

export default Vue.extend({
	props: {
		title: {
			type: String,
			required: true,
		},
		tooltip: {
			type: String,
			required: true,
		},
		size: {
			type: Number,
			default: 15,
		},
	},
	methods: {
		showPopup() {
			this.$nuxt.$emit('showExplanation', {
				title: this.title,
				text: this.tooltip,
			})
		},
	},
})
